import { Zap, ZDL } from '../types';

/** Returns a zap's ZDL, preferring the currently published version over the latest draft. */
export const getZDL = (zap: Zap): ZDL => (zap.current_version || zap.draft).zdl;

export default getZDL;
